import { GrTicket } from 'react-icons/gr';
import { BiParty } from 'react-icons/bi';
import { BiCloset } from 'react-icons/bi';
import { LiaCocktailSolid } from 'react-icons/lia';
import { MdOutlineFastfood } from 'react-icons/md';
import { FaCar } from 'react-icons/fa';
import { FaSmoking } from 'react-icons/fa';
import { PiBeerBottleBold } from 'react-icons/pi';
import { MdEmojiPeople } from 'react-icons/md';
import { FaRegStar } from 'react-icons/fa';

const getImage = (name: string) => {
  switch (name.toLowerCase()) {
    case 'reservas':
      return <GrTicket size={18} />;
    case 'eventos':
      return <BiParty size={18} />;
    case 'vestier':
      return <BiCloset size={18} />;
    case 'cocteleria':
      return <LiaCocktailSolid size={18} />;
    case 'comida':
      return <MdOutlineFastfood size={18} />;
    case 'estacionamiento':
      return <FaCar size={18} />;
    case 'área de fumadores':
      return <FaSmoking size={18} />;
    case 'barra libre':
      return <PiBeerBottleBold size={18} />;
    case 'servicio a la mesa':
      return <MdEmojiPeople size={18} />;
    default:
      return <FaRegStar size={18} />;
  }
};

const ServiceItem = ({ name }) => {
  return (
    <div className="flex items-center gap-3 text-gray-900">
      {/* Amenidad = contenido INFORMATIVO (no interactivo): sin hover. Ranura de icono de 36px
          (misma retícula que calendario/dirección/producto): el glifo se centra en el slot → su
          eje coincide con los iconos con caja. Sin caja/fondo/borde. */}
      <span className="w-9 shrink-0 flex items-center justify-center text-gray-900/60">
        {getImage(name)}
      </span>
      <span className="text-[16px] leading-tight">
        {name}
      </span>
    </div>
  );
};

export default ServiceItem;
